import React, { PureComponent } from 'react';

interface IPlusProps extends React.HTMLAttributes<Element> {
  size?: number;
}

export default class Plus extends PureComponent<IPlusProps, {}> {
  static defaultProps = {
    size: 10,
  };

  render() {
    const { size } = this.props;
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width={size}
        height={size}
      >
        <line strokeWidth="22" x1="0" y1="50" x2="100" y2="50" />
        <line strokeWidth="22" x1="50" y1="0" x2="50" y2="100" />
      </svg>
    );
  }
}
